/**
 * Normalize capability options returned by the adapter.
 * The adapter currently encodes options as an array of strings. We try to
 * interpret each element as JSON; if parsing fails we attempt a simple
 * `key=value` split. The result is a merged map of option keys -> values.
 */
export function normalizeOptions(
  input: unknown
): Record<string, unknown> | undefined {
  if (input == null) return undefined;
  if (typeof input === 'object' && !Array.isArray(input))
    return input as Record<string, unknown>;

  const arr = Array.isArray(input) ? input : [input];
  const out: Record<string, unknown> = {};

  for (const el of arr) {
    if (el == null) continue;
    if (typeof el === 'object') {
      Object.assign(out, el as Record<string, unknown>);
      continue;
    }

    const s = String(el).trim();
    if (!s) continue;

    try {
      const parsed = JSON.parse(s);
      if (typeof parsed === 'object') {
        Object.assign(out, parsed as Record<string, unknown>);
        continue;
      }
      out[`value_${Object.keys(out).length}`] = parsed;
      continue;
    } catch {
      // not JSON
    }

    const eq = s.indexOf('=');
    if (eq > 0) {
      const k = s.substring(0, eq).trim();
      const v = s.substring(eq + 1).trim();
      out[k] = v;
      continue;
    }

    out[`value_${Object.keys(out).length}`] = s;
  }

  return Object.keys(out).length ? out : undefined;
}
